module.exports = __webpack_public_path__ + "static/media/approved.94c18b0b.svg";